import { apiRequest } from './apiClient';

/**
 * Calendar data for one of the four journey views.
 *
 * The server derives the period bounds from the anchor date and returns them in
 * `period`, so the caller never computes week or month boundaries itself.
 *
 * @param {object} params
 * @param {'day'|'week'|'month'|'year'} params.view
 * @param {string} [params.date] - Anchor date, YYYY-MM-DD. Defaults to today (Eastern).
 * @param {number|string} [params.goalSettingId] - Restricts the calendar cells only.
 * @param {string} userId
 */
export const fetchJourney = ({ view = 'week', date, goalSettingId } = {}, userId) => {
	const params = new URLSearchParams({ view });
	if (date) params.set('date', date);
	if (goalSettingId != null && goalSettingId !== '') {
		params.set('goal_setting_id', goalSettingId);
	}
	return apiRequest(`/api/v1/users/me/journey?${params.toString()}`, { userId });
};

/**
 * The printable report. Presets are rolling windows ending today, not calendar
 * periods; `custom` takes explicit bounds and carries no AI text.
 *
 * @param {object} params
 * @param {'last_7_days'|'last_30_days'|'last_3_months'|'last_6_months'|'custom'} params.period
 * @param {string} [params.start] - custom only, YYYY-MM-DD
 * @param {string} [params.end] - custom only, YYYY-MM-DD
 * @param {string} userId
 */
export const fetchJourneyReport = (
	{ period = 'last_30_days', start, end } = {},
	userId
) => {
	const params = new URLSearchParams({ period });
	if (period === 'custom') {
		if (start) params.set('start', start);
		if (end) params.set('end', end);
	}
	return apiRequest(`/api/v1/users/me/journey/report?${params.toString()}`, {
		userId,
	});
};
